import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import AdminService from "../Services/AdminService";

const CompanyPlans = () => {
    const UserRoleID = localStorage.getItem("RoleID");
    const token = localStorage.getItem("JWTToken");
    const navigate = useNavigate();

    const [corporatePlans, setCorporatePlans] = useState([]);
    const [individualPlans, setIndividualPlans] = useState([]);
    const [activeTab, setActiveTab] = useState("Corporate");
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        if (UserRoleID === "3" && token) {
            const fetchData = async () => {
                try {
                    const corporateResponse = await AdminService.GetPlanDetailsCorporate(token);
                    if (corporateResponse && corporateResponse.RESPONSE) {
                        setCorporatePlans(corporateResponse.RESPONSE);
                        console.log(corporateResponse.RESPONSE)
                    }

                    const individualResponse = await AdminService.GetPlanDetailsIndividual(token);
                    if (individualResponse && individualResponse.RESPONSE) {
                        setIndividualPlans(individualResponse.RESPONSE);
                        console.log(individualResponse.RESPONSE)
                    }
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            };

            fetchData();
        } else {
            navigate("/Login");
        }
    }, [token, UserRoleID, navigate]);

    // Format Date Function
    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        if (isNaN(date)) return "Invalid Date";
        return date.toLocaleDateString("en-US", { day: "2-digit", month: "short", year: "numeric" });
    };

    // Handle tab change
    const handleTabChange = (tab) => setActiveTab(tab);

    // Handle search input change
    const handleSearchChange = (e) => setSearchQuery(e.target.value.toLowerCase());

    // Filter plans based on search input
    const filteredCorporatePlans = corporatePlans.filter((plan) =>
        Object.values(plan).some(
            (value) =>
                typeof value === "string" && value.toLowerCase().includes(searchQuery)
        )
    );

    const filteredIndividualPlans = individualPlans.filter((plan) =>
        Object.values(plan).some(
            (value) =>
                typeof value === "string" && value.toLowerCase().includes(searchQuery)
        )
    );

    // Render tabs dynamically
    const RenderTabs = () => {
        const currentPlans = activeTab === "Corporate" ? filteredCorporatePlans : filteredIndividualPlans;
        return (
            <>
                {currentPlans.length > 0 ? (
                    <div className="overflow-auto">
                        <div className="min-Width1100px">
                            <table className="table">
                                <thead className="bg-grey fs-14">
                                    <tr>
                                        {activeTab === "Corporate" ? (
                                            <th className="fw-6 bg-grey3 text-center">Company Name</th>
                                        ) : (
                                            <th className="fw-6 bg-grey3 text-center">Name</th>
                                        )}
                                        <th className="fw-6 bg-grey3">Survey Per Month</th>
                                        <th className="fw-6 bg-grey3">Cost Per Survey</th>
                                        <th className="fw-6 bg-grey3">Responder Per Month</th>
                                        <th className="fw-6 bg-grey3">Cost Per Responder</th>
                                        <th className="fw-6 bg-grey3">Plan Tier</th>
                                        <th className="fw-6 bg-grey3">Valid Till</th>
                                    </tr>
                                </thead>
                                <tbody className="fw-4 fs-14">
                                    {currentPlans.map((plan, index) => (
                                        <tr key={index} className="border-0">
                                            {activeTab === "Corporate" ? (
                                                <td className="bg-grey py-3 border-0">
                                                    <div className="d-flex gap-1 align-items-start">
                                                        <div className="col-3">
                                                            <img
                                                                src={plan.CompanyLogo}
                                                                className="PlanLogoSet"
                                                                alt="Company Logo"
                                                                style={{ borderRadius: "50%" }}
                                                            />
                                                        </div>
                                                        <div>
                                                            <div className="fw-bold fs-6">{plan.CompanyName || "N/A"}</div>
                                                            <div>{plan.ContactMail || "N/A"}</div>
                                                        </div>
                                                    </div>
                                                </td>
                                            ) : (
                                                <td className="bg-grey py-3 border-0">
                                                    <div className="d-flex gap-1 align-items-start">
                                                        <div className="col-3">
                                                            <img
                                                                src={plan.ProfileImageUrl || ""}
                                                                className="PlanLogoSet"
                                                                alt="Profile"
                                                                style={{ borderRadius: "50%" }}
                                                            />
                                                        </div>
                                                        <div>
                                                            <div className="fw-bold fs-6">{plan.Name || "N/A"}</div>
                                                            <div>{plan.Email || "N/A"}</div>
                                                        </div>
                                                    </div>
                                                </td>
                                            )}
                                            <td className="bg-grey py-3 border-0">{plan.SurveyPerMonth || "N/A"}</td>
                                            <td className="bg-grey py-3 border-0">{plan.CostPerSurvey || "N/A"}</td>
                                            <td className="bg-grey py-3 border-0">{plan.ResponderPerMonth || "N/A"}</td>
                                            <td className="bg-grey py-3 border-0">{plan.CostPerResponder || "N/A"}</td>
                                            <td className="bg-grey py-3 border-0">{plan.PlanTire || "N/A"}</td> {/* Corrected PlanTire to PlanType */}
                                            <td className="bg-grey py-3 border-0">{formatDate(plan.ValidTill)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : (
                    <p>No {activeTab.toLowerCase()} plans available.</p>
                )}
            </>
        );
    };

    return (
        <>
            <Header />
            <div className="bg-grey">

                <div className="container pt-4 min-hight85vh">
                    <h4 className="fw-bold">Company Plans</h4>
                    <div className="d-flex justify-content-between align-items-center my-4">
                        <div className="nav nav-tabs">
                            <button
                                className={`nav-link bg-grey ${activeTab === "Corporate" ? "active" : ""}`}
                                onClick={() => handleTabChange("Corporate")}
                            >
                                Corporate
                            </button>
                            <button
                                className={`nav-link bg-grey ${activeTab === "Individual" ? "active" : ""}`}
                                onClick={() => handleTabChange("Individual")}
                            >
                                Individual
                            </button>
                        </div>
                        <input
                            type="text"
                            placeholder="Search"
                            className="form-control w-25"
                            value={searchQuery}
                            onChange={handleSearchChange}
                        />
                    </div>
                    {RenderTabs()}
                </div>
            </div>
        </>
    );
};

export default CompanyPlans;
